import React, { useEffect } from 'react';

import { PostsTable } from '../components/PostsTable';
import { useAppDispatch, useAppSelector } from '../../../../../store';
import { useLazyGetPostsQuery } from '../service/posts.api';
import {
    selectAnalyticsFilters,
    updateFilters,
} from '../../../store/analyticFiltersSlice';
import { AnalyticsFiltersProps } from '../../AnalyticsFilters/service/filters.interface';

export const PostsContainer = () => {
    const filters = useAppSelector(selectAnalyticsFilters);
    const dispatch = useAppDispatch();

    const [
        getPosts,
        {
            data: messages = {
                total_messages: 0,
                posts: [],
            },
            isFetching,
            isLoading,
        },
    ] = useLazyGetPostsQuery();

    useEffect(() => {
        if (filters) {
            const payload = {
                ...filters,
                community_id: filters.chat,
            };
            getPosts(payload, true);
        }
    }, [filters]);

    const onFiltersUpdate = (update: Partial<AnalyticsFiltersProps>) => {
        dispatch(updateFilters(update));
    };

    return (
        <PostsTable
            loading={isLoading || isFetching}
            filters={filters}
            onFiltersUpdate={onFiltersUpdate}
            source={messages}
        />
    );
};
